import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { Reveal } from '../Reveal';
import { useLanguage } from '../../contexts/LanguageContext';
export function OnlineFormation() {
  const {
    t
  } = useLanguage();
  return <section className="bg-white py-24 sm:py-32" aria-labelledby="online-formation-heading" data-id="element-200" data-mp="1spnijqnvyxxn">
      <div className="mx-auto max-w-shell px-5 sm:px-8" data-id="element-201" data-mp="1xmdvi54e9deu">
        <div className="grid items-center gap-14 lg:grid-cols-2 lg:gap-20" data-id="element-202" data-mp="10x68sts1gy9c">
          <Reveal data-id="element-203" data-mp="10v3e3wfxygya">
            <div className="relative" data-id="element-204" data-mp="14yrm2g8hjek2">
              <div className="overflow-hidden rounded-4xl border border-ink/[0.06] shadow-lift" data-id="element-205" data-mp="14zt5b7znn7cv">
                <img src="https://cdn.magicpatterns.com/patterns/generated-images/4bd444a0-f893-4c2a-96c1-85b0cf549198.jpg" alt={t.formation.imageAlt} className="h-[320px] w-full object-cover sm:h-[440px]" data-id="element-206" data-mp="19wtcxnc5ki63" />
              </div>
              <div className="absolute -bottom-6 -right-2 w-[210px] rounded-3xl border border-white/50 bg-white/70 p-5 shadow-lift backdrop-blur-xl sm:right-6" data-id="element-207" data-mp="h8x9lzs2vs0c">
                <p className="text-[11px] font-semibold uppercase tracking-[0.16em] text-brand" data-id="element-208" data-mp="2m77zz2ssjq0u">
                  {t.formation.badgeLabel}
                </p>
                <p className="mt-2 text-[15px] font-semibold leading-snug text-ink" data-id="element-209" data-mp="2i7qsy4xpuktk">
                  {t.formation.badgeBody}
                </p>
              </div>
            </div>
          </Reveal>

          <Reveal delay={0.1} data-id="element-210" data-mp="23ggr02cpu1mz">
            <div data-id="element-211" data-mp="23gqi5t9hyeu9">
              <p className="text-[12px] font-semibold uppercase tracking-[0.2em] text-brand" data-id="element-212" data-mp="23h9osdtp5gsz">
                {t.formation.eyebrow}
              </p>
              <h2 id="online-formation-heading" className="headline mt-5 text-[32px] font-bold text-ink sm:text-[44px]" data-id="element-213" data-mp="1ufsfbeasodd9">
                {t.formation.heading}
              </h2>
              <p className="mt-6 text-[17px] leading-relaxed text-ink/65" data-id="element-214" data-mp="1pis8h164f6l3">{t.formation.body}</p>
              <a href="#consultation" className="group mt-9 inline-flex items-center gap-2 rounded-2xl bg-brand px-7 py-4 text-[15px] font-semibold text-white shadow-glow transition-all duration-300 hover:-translate-y-0.5 hover:bg-brand-600" data-id="element-215" data-mp="3orqm79lmsx5z">
                {t.formation.cta}
                <ArrowRightIcon className="h-[18px] w-[18px] transition-transform duration-300 group-hover:translate-x-1" aria-hidden="true" data-id="element-216" data-mp="bm8p1171xif0" />
              </a>
            </div>
          </Reveal>
        </div>
      </div>
    </section>;
}